// App.jsx
import React from "react";
import PercentageBarChart from "./PercentageBarChart";

const data = [
  { name: "18-25", value: 8 },
  { name: "26-30", value: 14 },
  { name: "31-35", value: 22 },
  { name: "26-40", value: 21 },
  { name: "41-45", value: 14 },
  { name: "46-50", value: 8 },
  { name: "51-55", value: 6 },
  { name: "56-60", value: 5 },
  { name: "61-65", value: 2 },
];

function CustomChartView({ dataChart }) {
  const stateDataChart = dataChart
    ? Array.isArray(dataChart)
      ? dataChart
      : data
    : data;
  return (
    <div style={{ padding: "2rem" }}>
      <h2>Mosha Custom Chart</h2>
      <PercentageBarChart chartData={stateDataChart} />
    </div>
  );
}

export default CustomChartView;
